import { ILocation } from '../types';

const toRadians = (deg: number) => (deg * Math.PI) / 180;

export const calcDistanceKm = (location1: ILocation, location2: ILocation) => {
    const { lat: latLoc1, lng: lngLoc1 } = location1;
    const { lat: latLoc2, lng: lngLoc2 } = location2;

    const radlat1 = toRadians(latLoc1);
    const radlat2 = toRadians(latLoc2);
    const theta = lngLoc1 - lngLoc2;
    const radtheta = toRadians(theta);

    let dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);

    if (dist > 1) dist = 1;

    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    dist *= 1.609344;

    return dist;
};

export const displayDistance = (dist: number) => {
    const unit = dist < 1 ? 'm' : 'km';
    const displayedDistance = dist < 1 ? dist * 1000 : dist;
    const numDecimals = dist < 1 ? 0 : 1;

    return displayedDistance.toFixed(numDecimals) + unit;
};
